import React, { forwardRef } from 'react';
import {
  MultiSelect,
  MultiSelectOption
} from '../../../FormFields/MultiSelect';
import { TextInputType } from '../../../FormFields/shared';

interface FilterSelectProps {
  label: string;
  options: string[];
  value: string[];
  onSelect: (value: string[]) => void;
}

export const FilterSelect = forwardRef(
  ({ label, options, value, onSelect }: FilterSelectProps, ref) => {
    const optionsMap: MultiSelectOption[] = [];

    options.forEach((element) => {
      const multiSelectObject: any = {};
      multiSelectObject['key'] = element;
      multiSelectObject['value'] = element;
      optionsMap.push(multiSelectObject);
    });

    return (
      <MultiSelect
        ref={ref}
        type={TextInputType.TEXT}
        label={label}
        options={optionsMap}
        className="!h-12 items-center !rounded-[17px] !border-teal !bg-white !py-2.5 !pl-4 !text-black tablet:!bg-[center_right_0.7rem]"
        handleChange={onSelect}
        value={value}
        data-testid="filter-select"
      />
    );
  }
);
